import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Medallion } from './Medallion';
import { brandName } from '../data/copy';
export function GuaranteeSection() {
  return <section className="w-full bg-slate-950 py-10 [contain-intrinsic-size:auto_900px] [content-visibility:auto] sm:py-14 [.chalk_&]:bg-slate-50" aria-labelledby="guarantee-heading" data-id="element-114" data-mp="9ucrn7u79n36">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-115" data-mp="ercznoam0zwx">
        <Medallion icon={ShieldCheckIcon} data-id="element-116" data-mp="jrhc938edahv" />

        <p className="mt-6 text-sm font-bold uppercase tracking-[0.22em] text-orange-400 [.chalk_&]:text-orange-600" data-id="element-117" data-mp="jqpsqqs2r37y">
          7-day guarantee
        </p>
        <h2 id="guarantee-heading" className="mt-2 text-4xl font-extrabold uppercase leading-none tracking-tight text-slate-50 sm:text-5xl [.chalk_&]:text-slate-900" data-id="element-118" data-mp="sm5k915cx6ad">
          100% protected
        </h2>

        <div className="mx-auto mt-7 max-w-prose space-y-4 text-lg leading-relaxed text-slate-400 [.chalk_&]:text-slate-600" data-id="element-119" data-mp="12kbmxkyzmgga">
          <p data-id="element-120" data-mp="17g0p7w2e6bga">
            Access {brandName} and make sure you receive the 6 volumes and 5
            bonuses described on this page.
          </p>
          <p data-id="element-121" data-mp="20sklg0b0zivc">
            If a file is incomplete, you experience an access problem or the
            delivered material does not match the description of this offer,
            contact us within 7 days.
          </p>
          <p data-id="element-122" data-mp="1rth16t04gxf9">We will review the issue and work to resolve it.</p>
          <p data-id="element-123" data-mp="2oiy4x2fjo9eb">
            If we cannot resolve it, you will receive a{' '}
            <span className="font-semibold text-slate-50 [.chalk_&]:text-slate-900" data-id="element-124" data-mp="2jjbtmyja1385">full refund</span>.
          </p>
        </div>
        <p className="mt-8 text-xl font-extrabold uppercase tracking-tight text-orange-400 [.chalk_&]:text-orange-600" data-id="element-125" data-mp="2ertsa9dcd0mn">
          No unnecessary risk for you.
        </p>
      </div>
    </section>;
}